import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-site-history',
  imports: [MatCardModule, FontAwesomeModule],
  templateUrl: './site-history.component.html',
  styleUrl: './site-history.component.scss',
})
export class SiteHistoryComponent {}
